module.exports = __webpack_public_path__ + "static/media/protocogotas_text_04.3e2cf2f8.jpg";